import React, { useContext } from 'react'
import Translations from '@helpers/translations'
import { ProductWithVariants } from 'types/product'
import { sizeChartUrl } from '@helpers/sizeChart'
import Link from '@components/ui/Link/index'
import styles from './styles.module.scss'
import { fitInstructions } from '@helpers/products/fitInstructions'
import ProductContext from '../context'

type Props = {
  product: ProductWithVariants
}

function SizeAndFitInstructions({ product }: Props) {
  const { hasSizeChart } = useContext(ProductContext)
  const {
    options: productOptions,
    product_type: productType,
    product_feed: productFeed
  } = product

  return (
    <ul>
      {fitInstructions[productType]
        .split('|')
        .map(
          (line, index) => line && <li key={`fit-line-${index}`}>{line}</li>
        )}
      {hasSizeChart && (
        <li className={styles.links} key={'fit-line-11'}>
          Fine-tuning? See the &nbsp;
          <Link
            text={Translations.localise('product.filters.size-chart')}
            href={sizeChartUrl(
              productOptions,
              productType,
              productFeed?.product_category
            )}
          />
        </li>
      )}
    </ul>
  )
}

export default SizeAndFitInstructions
